import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function GripIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7C11 7.55228 10.5523 8 10 8C9.4477 8 9 7.55228 9 7C9 6.44772 9.4477 6 10 6C10.5523 6 11 6.44772 11 7ZM11 12C11 12.5523 10.5523 13 10 13C9.4477 13 9 12.5523 9 12C9 11.4477 9.4477 11 10 11C10.5523 11 11 11.4477 11 12ZM10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16C9.4477 16 9 16.4477 9 17C9 17.5523 9.4477 18 10 18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 7C15.5 7.55228 15.0523 8 14.5 8C13.9477 8 13.5 7.55228 13.5 7C13.5 6.44772 13.9477 6 14.5 6C15.0523 6 15.5 6.44772 15.5 7ZM15.5 12C15.5 12.5523 15.0523 13 14.5 13C13.9477 13 13.5 12.5523 13.5 12C13.5 11.4477 13.9477 11 14.5 11C15.0523 11 15.5 11.4477 15.5 12ZM14.5 18C15.0523 18 15.5 17.5523 15.5 17C15.5 16.4477 15.0523 16 14.5 16C13.9477 16 13.5 16.4477 13.5 17C13.5 17.5523 13.9477 18 14.5 18Z"
        fill="currentColor"
      />
    </svg>
  );
};
